var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-items" },
    [
      _c("vs-td", { attrs: { data: _vm.item.valor } }, [
        _vm._v(" " + _vm._s(_vm.item.valor) + " ")
      ]),
      _c("vs-td", { attrs: { data: _vm.item.descripcion } }, [
        _vm._v(" " + _vm._s(_vm.item.descripcion) + " ")
      ]),
      _c("vs-td", { attrs: { data: _vm.item.extra.descripcion } }, [
        _vm._v(" " + _vm._s(_vm.item.extra.descripcion) + " ")
      ]),
      _c("vs-td", { attrs: { data: _vm.item.extra.fechaCreacion } }, [
        _vm._v(" " + _vm._s(_vm.item.extra.fechaCreacion) + " ")
      ]),
      _c(
        "vs-td",
        [
          _c("vs-switch", {
            attrs: { color: "primary" },
            on: {
              click: function($event) {
                return _vm.toggleEnableTemplate({
                  item: _vm.item,
                  selected: _vm.selected
                })
              }
            },
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })
        ],
        1
      ),
      _c(
        "vs-td",
        [
          _c(
            "vs-dropdown",
            { attrs: { "vs-custom-content": "", "vs-trigger-click": "" } },
            [
              _c(
                "a",
                { staticClass: "a-icon", attrs: { "href.prevent": "" } },
                [
                  _c("vs-icon", {
                    attrs: {
                      icon: "bubble_chart",
                      size: "medium",
                      bg: "#E4E4E4",
                      round: "",
                      color: "gray"
                    }
                  })
                ],
                1
              ),
              _c("vs-dropdown-menu", [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.editTemplate(_vm.item)
                      }
                    }
                  },
                  [
                    _c("vs-icon", { attrs: { icon: "edit", color: "gray" } }),
                    _vm._v(" Editar ")
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }